/**
 * Which items an individual sub-track's context menu offers.
 *
 * A sub-track is archived and unarchived on its own, but an archived parent
 * must not end up with an active child, so unarchiving a sub-track is only
 * possible while its parent is active — the server rejects that call.
 * Unarchiving the parent is the route back to active.
 *
 * `move` is the pointer-free route to the reparent a cross-parent drag
 * performs. It needs an active sub-track for the same reason unarchive does,
 * read the other way round: moving a sub-track out of an archived parent would
 * also leave that parent with a child it must not have.
 */
export type SubTrackContextMenuItem = 'archive' | 'unarchive' | 'move';

export function getSubTrackContextMenuItems({
  isSubTrack,
  isArchived,
  isParentArchived,
  flagEnabled,
  moveAvailable,
}: {
  isSubTrack: boolean;
  isArchived: boolean;
  isParentArchived: boolean;
  flagEnabled: boolean;
  /** Whether the caller wired the move flow up at all. */
  moveAvailable: boolean;
}): SubTrackContextMenuItem[] {
  // This decides which actions exist, not who may take them. A parent track's
  // items are rendered — and permission-disabled — by the menu itself, and
  // sub-track items are treated the same way, so an item is offered here
  // whether or not the viewer holds `plan.tracks` archive.
  if (!isSubTrack || !flagEnabled) return [];
  if (isArchived) return isParentArchived ? [] : ['unarchive'];
  return moveAvailable ? ['archive', 'move'] : ['archive'];
}
